/**
 * Faculty Tag
 */
import { z } from 'zod';
import {
  FacultyTagId,
  FacultyId,
  UnixTimestamp,
} from '../types/branded';
import { TagScopeSchema } from '../types/enums';

export const FacultyTagSchema = z.object({
  id: FacultyTagId,
  facultyId: FacultyId,
  label: z.string().min(1).max(120),
  scope: TagScopeSchema.default('internal'),
  color: z.string().min(1).optional(),
  createdAt: UnixTimestamp,
  updatedAt: UnixTimestamp,
});
export type FacultyTag = z.infer<typeof FacultyTagSchema>;
